import React from 'react'
import { FormControl, FormGroup, Row, Col, ControlLabel } from 'react-bootstrap'
import i18next from 'i18next'
import { Link } from 'react-router'
import Notificator from './Notificator'
import Button from './Button'

import styles from './styles/app.scss'
import loginStyles from './styles/login.scss'

import illustration from './../assets/images/wopi-wide.png'

export default class Login extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      username: '',
      password: ''
    }
  }

  render() {
    return (
      <section className={loginStyles.login}>
        <Row>
          <Col sm={6} smOffset={3} md={4} mdOffset={4}>
            <h1>{i18next.t('log_in')}</h1>

            <form>
              <div className={styles.informationFormGroup}>
                <FormGroup>
                  <ControlLabel>{i18next.t('email')}</ControlLabel>
                  <FormControl
                    type="email"
                    value={this.state.username}
                    placeholder={i18next.t('email_address')}
                    name="username"
                    onChange={this.onChange.bind(this)}
                    tabIndex={1}
                  />
                </FormGroup>

                <FormGroup>
                  <ControlLabel>
                    {i18next.t('password')}

                    <Link to="/forgot-password" style={{ marginLeft: 5 }}>
                      {i18next.t('forgot')}
                    </Link>
                  </ControlLabel>

                  <FormControl
                    type="password"
                    value={this.state.password}
                    placeholder={i18next.t('password')}
                    name="password"
                    onChange={this.onChange.bind(this)}
                    tabIndex={2}
                  />
                </FormGroup>
              </div>

              {this.props.hasLoginFailed === true && (
                <Notificator type="error">{i18next.t('login_failed')}</Notificator>
              )}

              <p style={{ textAlign: 'center' }}>
                <Button text={i18next.t('login')} onClick={e => this.login(e)} tabIndex={3} />
              </p>
            </form>
          </Col>
        </Row>

        <p>
          <img src={illustration} alt="WOPI" />
        </p>
      </section>
    )
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  login(e) {
    e.preventDefault()

    this.props.onLogin(this.state.username, this.state.password)
  }
}



// WEBPACK FOOTER //
// ./src/components/Login.js